/*
    © 2021 EcomGraduates
*/

// Product options
document.querySelectorAll('.product-option')
    .forEach((option) => {
        option.addEventListener('change', () => {
            const selectedOptions = []
            document.querySelectorAll('.product-option').forEach((option) => {
                if (option.type === 'radio') {
                    if (option.checked) {
                        selectedOptions.push(option.value)
                    }
                } else {
                    selectedOptions.push(option.value)
                }
            })

            const selectedVariant = window.product.variants.find((variant) =>
                JSON.stringify(variant.options) === JSON.stringify(selectedOptions))

            const addToCartBtn = document.querySelector('#add-to-cart-btn')
            // const buyItNowBtn = document.querySelector('#btn-buy-it-now')

            addToCartBtn.setAttribute('data-variant-id', selectedVariant?.id || '')

            if(option.hasAttribute('data-product-swatch-input')) {
                if(option.closest('li').querySelector('[data-color-swatch]')) {
                    const colorName = option.closest('li').querySelector('[data-color-swatch]').dataset.colorSwatch;
                    const popupVariants = document.querySelectorAll('.free-gift-variants');
                    popupVariants.forEach((select) => {
                        let target = select.querySelector(`option[data-color="${colorName}"]`);
                        if(target) {
                            select.closest('.free-gift-product').dataset.variantId = target.dataset.variantId;
                        }
                    })
                }
            }

            if (selectedVariant) {

                document.querySelector('select[name="id"]').value = selectedVariant.id

                if (selectedVariant.available) {
                    addToCartBtn.disabled = false
                    addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart
                } else {
                    addToCartBtn.disabled = true
                    addToCartBtn.textContent = addToCartBtn.dataset.textSoldOut
                }
                document.querySelector('.product-price .product-price-final')
                    .textContent = window.formatMoney(selectedVariant.price)
                if (selectedVariant.compare_at_price) {
                    document.querySelector('.product-price .product-price-compare')
                        .textContent = window.formatMoney(selectedVariant.compare_at_price)
                    document.querySelector('.product-price .product-price-compare')
                        .classList.remove('d-none')
                } else {
                    document.querySelector('.product-price .product-price-compare')
                        .classList.add('d-none')
                }
                window.history.replaceState({}, '', `${window.product.url}?variant=${selectedVariant.id}`)

                if (selectedVariant.featured_media) {
                    bootstrap.Carousel.getInstance('#product-carousel').to(selectedVariant.featured_media.position - 1)
                }

                const backInStockArea = document.querySelector('#custom-klaviyo-back-in-stock')

                if (backInStockArea) {
                    if (selectedVariant.available) {
                        backInStockArea.style.display = 'none'
                    } else {
                        backInStockArea.style.display = 'block'
                    }
                }
            } else {
                addToCartBtn.disabled = true
                addToCartBtn.textContent = addToCartBtn.dataset.textUnavailable
                window.history.replaceState({}, '', window.product.url)
            }
        })
    })


// Add to cart - Product page

async function atcEventHandler(form, item = null, is_addition = false) {
    let selFrequency = document.querySelector('.custom-recharge-select.checked-radio .recharge-plan-dropdown');
    if(selFrequency && selFrequency.value == 'no-frequency') {
        selFrequency.classList.add('error');
        return;
    }
    else if(selFrequency) {
        selFrequency.classList.remove('error');
    }

    const btn = form.querySelector('#add-to-cart-btn');
    let savedBtnInnerHTML = btn.innerHTML;
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    setTimeout(() => {
        btn.innerHTML = savedBtnInnerHTML;
    }, 1500);

    const subscriptionInputType = form.querySelector(".custom-recharge-widget input");

    const subscriptionBoolean = (form.querySelector('.recharge-widget-type-list input:checked') || form.querySelector('.recharge-variant-plan-block.active')) ? true : false;

    let formData;

    const id = Number(form.querySelector('[name="id"]').value)
    const qty = Number(form.querySelector('[name="quantity"]')?.value || '1')

    if (subscriptionBoolean) {
        const sellingPlan = form.querySelector("#current_plan").value;
        formData = {
            items: [
                {
                    id: id,
                    quantity: qty,
                    selling_plan: sellingPlan
                }
            ]
        }
    } else {
        formData = {
            items: [
                {
                    id: id,
                    quantity: qty
                }
            ]
        }
    }

    if(item) {
        if(!is_addition) {
            formData.items = [];
        }
        formData.items.push(item);
    }

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
    const data = await response.json();
    if (typeof handleGwp !== 'undefined') {
      await handleGwp();  
    }
    if(btn.hasAttribute('data-gwp-pair') && btn.dataset.gwpPairExist == 'false') {
        let target = btn.dataset.target;
        let popup = document.querySelector(`divi-popup[data-handle="${target}"]`);
        if(popup) {
            popup.classList.add('open');
        }
    }
    
    btn.innerHTML = savedBtnInnerHTML;
    btn.blur();

    document.dispatchEvent(new CustomEvent('cart:build'));

    if(!(btn.hasAttribute('data-gwp-pair') && btn.dataset.gwpPairExist == 'false')) {
        document.dispatchEvent(new CustomEvent('cart:open'));
    }

    // FB pixel event
    const cartCurrencyIsoCode = window.cart_currency_iso_code;
    const productPrice = data.items && data.items.length > 0 ? data.items[0].final_price / 100 : data.final_price / 100;
    fbq("track", "AddToCart", {
        currency: cartCurrencyIsoCode,
        value: productPrice,
    });
}

function initCartFormHandler() {

    document.querySelectorAll('form[action="/cart/add"]:not(.modal-form)').forEach(form => {

        let _btn = form.querySelector('#add-to-cart-btn');
        if(_btn) {
            _btn.addEventListener('click', (e) => {
                e.preventDefault();
                if(e.target.dataset.giftChoiceRequired == 'true') {
                    let popup = document.querySelector(`divi-popup[data-handle="free-gift-choice"]`);
                    let btnAddGift = popup.querySelector('.free-gift-add');
                    let activeGiftItem = popup.querySelector('.free-gift-product.active');
                    popup.classList.add('open');

                    popup.querySelectorAll('[data-divi-popup-close]').forEach((close) => {
                        close.addEventListener('click', () => {
                            atcEventHandler(form);        
                        })
                    })
                    popup.querySelectorAll('.free-gift-product').forEach((g_product) => {
                        g_product.addEventListener('click', () => {
                            btnAddGift.classList.add('active');
                            if(!g_product.classList.contains('active')) {
                                popup.querySelector('.free-gift-product.active')?.classList.remove('active');
                                g_product.classList.add('active');
                            }
                            activeGiftItem = g_product;
                        })
                    })
                    btnAddGift.addEventListener('click', () => {
                        let giftItem = {
                            id: activeGiftItem.dataset.variantId,
                            quantity: 1
                        }
                        atcEventHandler(form, giftItem);
                        popup.classList.remove('open');    
                    })
                }
                else if(e.target.dataset.upsellRequired == 'true') {
                    let popup = document.querySelector(`divi-popup[data-handle="upsell-popup"]`);
                    let btnAddUpsell = popup.querySelector('.upsell-add');
                    popup.classList.add('open');

                    popup.querySelectorAll('[data-divi-popup-close]').forEach((close) => {
                        close.addEventListener('click', () => {
                            atcEventHandler(form);        
                        })
                    })
                    btnAddUpsell.addEventListener('click', () => {
                        let giftItem = {
                            id: btnAddUpsell.dataset.upsellId,
                            quantity: 1
                        }
                        atcEventHandler(form, giftItem, true);
                        popup.classList.remove('open');
                    })
                }
                else {
                    // form.submit();
                    atcEventHandler(form);
                }
            })
        }

        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            atcEventHandler(form);
        })
    })
}

// Function call to initialize the handler
initCartFormHandler();

// Place the function in a window object
window.initCartFormHandler = initCartFormHandler;

//Add to cart - form modal recommend
function initCartFormModal() {
    document.querySelectorAll('.buy-product-modal form[action="/cart/add"]').forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault()

            const btn = form.querySelector('#add-to-cart-btn');
            let savedBtnInnerHTML = btn.innerHTML
            btn.innerHTML = `
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            `

            const subscriptionBoolean = form.querySelector('.recharge-widget-type-list input:checked') ? true : false;

            let response

            if (subscriptionBoolean) {
                const id = Number(form.querySelector('[name="id"]').value)
                const sellingPlan = form.querySelector("#current_plan").value;
                const qty = Number(form.querySelector('[name="quantity"]').value || '1')

                const formData = {
                    items: [{
                        id: id,
                        quantity: qty,
                        selling_plan: sellingPlan
                    }]
                }
                response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                })
            } else {
                response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
            }

            const data = await response.json();

            // FB pixel event
            const cartCurrencyIsoCode = window.cart_currency_iso_code;
            const productPrice = data.items && data.items.length > 0 ? data.items[0].final_price / 100 : data.final_price / 100;
            fbq("track", "AddToCart", {
                currency: cartCurrencyIsoCode,
                value: productPrice,
            });

            window.closeQuickModal();
            btn.innerHTML = savedBtnInnerHTML;
            btn.blur();
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));

        })
    })
}

// Place the function in a window object
window.initCartFormModal = initCartFormModal;

// Add subscriptions to cart (on product lists)
Window.customRechargeWidget = () => {
    document.querySelectorAll('.product-list-item .recharge-widget-input').forEach(input => {
        input.addEventListener('change', async () => {
            const label = input.closest('li').querySelector('label')
            const id = Number(input.dataset.variantId)
            const sellingPlan = input.value
            const qty = 1

            label.innerHTML = `
                <div class="spinner-border spinner-border-sm" role="status" style="border-width: 0.15em;">
                    <span class="visually-hidden">Loading...</span>
                </div>
            `

            const formData = {
                items: [{
                    id: id,
                    quantity: qty,
                    selling_plan: sellingPlan
                }]
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            })

            const data = await response.json()

            handleGwp();

            label.innerHTML = label.dataset.text;
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));

            // FB pixel event
            const cartCurrencyIsoCode = window.cart_currency_iso_code
            const productPrice = data.items[0].final_price / 100
            fbq('track', 'AddToCart', { currency: cartCurrencyIsoCode, value: productPrice })


        })
    })
}

Window.customRechargeWidget();

// Recommended products
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('#recommended-products')
    if (recommendedProducts) {
        const { sectionId, baseUrl, productId, limit } = recommendedProducts.dataset
        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`
        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data
                document.querySelectorAll('[data-bs-toggle="popover"]')
                    .forEach((el) => new bootstrap.Popover(el))
            })
            .finally(() => {
                if (typeof yotpo !== 'undefined') {
                    new Yotpo.API(yotpo).refreshWidgets();
                }
                Window.customRechargeWidget();
                handleATCProductListItem();
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.target.querySelector('#recommended-products').dataset.sectionId
    if (e.detail.sectionId === sectionId) {
        initRecommendedProducts()
    }
})

//
// Bought Together (cross-sells)
//
const initBoughtTogether = () => {
    const section = document.querySelector('#bought-together')

    if (!section) {
        return false
    }

    // Hide section if no cross-sells are avaiable
    if (section.querySelectorAll('.product-list-item').length <= 1) {
        section.style.display = 'none'
        return false
    }

    // Fade product-list-item if product is changed checked
    // Update bundle total price
    section.querySelectorAll('.form-check-input').forEach((el) => {
        el.addEventListener('change', (e) => {
            if (e.target.checked) {
                section.querySelector(`[data-product-id="${e.target.dataset.productId}"]`).style.opacity = '1'
            } else {
                section.querySelector(`[data-product-id="${e.target.dataset.productId}"]`).style.opacity = '0.25'
            }
            let bundlePrice = 0
            section.querySelectorAll('.form-check-input').forEach((el) => {
                if (el.checked) {
                    const selectEl = el.closest('.bought-together-list-item').querySelector('select')
                    bundlePrice += Number(selectEl[selectEl.selectedIndex].dataset.price)
                }
            })
            section.querySelector('#bought-together-atc-btn span').innerText = window.formatMoney(bundlePrice)
        })
    })

    // Update bundle total price if a new variant is selected
    section.querySelectorAll('.form-select').forEach((el) => {
        el.addEventListener('change', (e) => {
            let bundlePrice = 0
            section.querySelectorAll('.form-check-input').forEach((el) => {
                if (el.checked) {
                    const selectEl = el.closest('.bought-together-list-item').querySelector('select')
                    bundlePrice += Number(selectEl[selectEl.selectedIndex].dataset.price)
                }
            })
            section.querySelector('#bought-together-atc-btn span').innerText = window.formatMoney(bundlePrice)
        })
    })

    // Handle add to cart
    section.querySelector('#bought-together-atc-btn').addEventListener('click', (e) => {
        const btn = e.target
        const btnInnerHTML = btn.innerHTML
        btn.style.width = btn.offsetWidth + 'px'
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `
        const formData = {
            items: []
        }
        section.querySelectorAll('.form-check-input').forEach((el) => {
            if (el.checked) {
                const variantId = el.closest('.bought-together-list-item').querySelector('select').value
                formData.items.unshift({
                    id: Number(variantId),
                    quantity: 1
                })
            }
        })

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((data) => {
                fetch(window.location.href)
                    .then((response) => response.text())
                    .then((data) => {
                        const parser = new DOMParser()
                        const newDocument = parser.parseFromString(data, 'text/html')
                        document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                        const offcanvas = new bootstrap.Offcanvas(document.querySelector('#offcanvas-cart'))
                        offcanvas.show()
                        window.initCartQty()
                        btn.innerHTML = btnInnerHTML
                        btn.blur()
                        document.querySelectorAll('.cart-items-count').forEach((el) => {
                            el.textContent = Number(el.textContent) + formData.items.length
                        })
                    })
            })
    })
}
initBoughtTogether()

/*
    Sticky ATC
*/

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight + 50 || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Handle plus/minus in quantity input field

document.body.addEventListener('click', (e) => {
    if(e.target.classList.contains('btn-plus-minus')) {
        let quantityInput = e.target.closest('.quantity-wrapper').querySelector('input[name="quantity"]')
        let quantity = Number(quantityInput.value)
        if (e.target.classList.contains('btn-minus')) {
            if (quantity > 1) {
                quantityInput.value = quantity - 1;
            }
        } else {
            quantityInput.value = quantity + 1;
            console.log("Cantidad aumentada");
        }
    }
})

// document.querySelectorAll('.quantity-wrapper .btn-plus-minus').forEach((el) => {
//     el.addEventListener('click', (e) => {
//         const quantityInput = el.closest('.quantity-wrapper').querySelector('input[name="quantity"]')
//         const quantity = Number(quantityInput.value)
//         if (el.classList.contains('btn-minus')) {
//             if (quantity > 1) {
//                 quantityInput.value = quantity - 1
//             }
//         } else {
//             quantityInput.value = quantity + 1
//         }
//     })
// })

// Recharge widget
if (!document.querySelectorAll('.page-type-product').length) {
    document.querySelectorAll('[name="recharge-widget-type"]').forEach((input) => {
        input.addEventListener("change", () => {
            const finalPriceEl = input.closest("#product-content-area").querySelector("[data-product-price]");

            if (input.value === "one-time") {
                document.querySelector("#recharge-widget-schedule-list-wrapper").style.display = "none";
                finalPriceEl.textContent = window.formatMoney(
                    finalPriceEl.dataset.productPrice
                );
            } else {
                document.querySelector("#recharge-widget-schedule-list-wrapper").style.display = "block";
                finalPriceEl.textContent = window.formatMoney(
                    finalPriceEl.dataset.subPrice
                );
            }
        });
    });
}


// Klaviyo back-in-stock feature through API
// https://developers.klaviyo.com/en/docs/how-to-set-up-custom-back-in-stock
const initKlaviyoBackInStock = () => {
    const form = document.querySelector('#custom-klaviyo-back-in-stock');
    const klaviyoListID = form?.dataset?.klaviyoListId || 'UfPd6m';

    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault()

            form.querySelector('button').innerHTML = `
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            `

            const email = form.querySelector('[type="email"]').value
            const variantId = document.querySelector('#product-form [name="id"]').value

            const response = await fetch('http://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
                method: 'POST',
                body: new URLSearchParams({
                    a: klaviyoListID,
                    email: email,
                    variant: Number(variantId),
                    platform: 'shopify'
                })
            })


            if (response.status === 200) {
                form.querySelector('#custom-klaviyo-back-in-stock-error').style.display = 'none'
                form.querySelector('#custom-klaviyo-back-in-stock-error').innerHTML = ''
                form.querySelector('#custom-klaviyo-back-in-stock-success').style.display = 'block'
                form.querySelector('#custom-klaviyo-back-in-stock-success').innerHTML =
                    form.querySelector('#custom-klaviyo-back-in-stock-success').dataset.text
            } else {
                form.querySelector('#custom-klaviyo-back-in-stock-success').style.display = 'none'
                form.querySelector('#custom-klaviyo-back-in-stock-success').innerHTML = ''
                form.querySelector('#custom-klaviyo-back-in-stock-error').style.display = 'block'
                form.querySelector('#custom-klaviyo-back-in-stock-error').innerHTML =
                    form.querySelector('#custom-klaviyo-back-in-stock-error').dataset.text
            }

            form.querySelector('button').innerHTML = form.querySelector('button').dataset.text
        })
    }
}
initKlaviyoBackInStock();

const initKlaviyoComingSoon = () => {
    const form = document.querySelector('#custom-klaviyo-coming-soon');

    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault()
            const email = form?.querySelector('[type="email"]').value;
            const klaviyoListId = form?.dataset?.klaviyoListId;
            const myHeaders = new Headers();
          debugger;

            myHeaders.append("x-shop-id", "divi-store");
            myHeaders.append("x-list-id", klaviyoListId);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "email": email,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://middleware-api-bay.vercel.app/api/marketing/divisubscribe", requestOptions)
                .then((response) => response.text())
                .then((result) => {
                    form.querySelector('#custom-klaviyo-back-in-stock-error').style.display = 'none'
                    form.querySelector('#custom-klaviyo-back-in-stock-error').innerHTML = ''
                    form.querySelector('#custom-klaviyo-back-in-stock-success').style.display = 'block'
                    form.querySelector('#custom-klaviyo-back-in-stock-success').innerHTML =
                    form.querySelector('#custom-klaviyo-back-in-stock-success').dataset.text
                })
                .catch((error) => {
                    console.error(error);
                    form.querySelector('#custom-klaviyo-back-in-stock-success').style.display = 'none'
                    form.querySelector('#custom-klaviyo-back-in-stock-success').innerHTML = ''
                    form.querySelector('#custom-klaviyo-back-in-stock-error').style.display = 'block'
                    form.querySelector('#custom-klaviyo-back-in-stock-error').innerHTML =
                    form.querySelector('#custom-klaviyo-back-in-stock-error').dataset.text
                });
        });
    }
}
initKlaviyoComingSoon();
